import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Text } from '@rsos/components/capstone/base';
import { useGetEventSharesByPhoneQuery } from '@rsos/reduxDataStore/src/features/eventShare/eventShareApi';
import { EventShare } from '@rsos/reduxDataStore/src/features/eventShare/types';
import { useCurrentOrgName } from '@rsos/sinatra/src/selectors';
import useHasAccessToFieldSharing from '../../../../hooks/useHasAccessToFieldSharing';
import { AppState } from '../../../../types/AppState';
import EventShareAccordion from './EventShareAccordion/index';

const EventShareCard = () => {
  const [openAccordionId, setOpenAccordionId] = useState<string | null>(null);
  const showFieldSharing = useHasAccessToFieldSharing();

  const orgName = useCurrentOrgName();
  const selectedCallerID = useSelector(
    (state: AppState) => state.emergencyCalls.selectedCallerID,
  );

  const { data: eventShareData, isLoading } = useGetEventSharesByPhoneQuery(
    {
      org: orgName || '',
      phoneNumber: selectedCallerID ? `tel://${selectedCallerID}` : '',
    },
    {
      skip: !showFieldSharing || !orgName || !selectedCallerID,
    },
  );

  // Don't render if: flag+capability off, loading, or no data
  if (
    !showFieldSharing ||
    isLoading ||
    !eventShareData ||
    eventShareData.length === 0
  ) {
    return null;
  }

  const handleAccordionToggle = (sessionId: string) => {
    setOpenAccordionId(prevId => (prevId === sessionId ? null : sessionId));
  };

  return (
    <Box width="100%" bg="background">
      <Text size="normal" color="primaryText" fontWeight="bold" p="16px">
        Event Shared with Field Responders
      </Text>
      {eventShareData.map((share: EventShare) => (
        <EventShareAccordion
          key={share.session_id}
          share={share}
          isOpen={openAccordionId === share.session_id}
          onToggle={() => handleAccordionToggle(share.session_id)}
        />
      ))}
    </Box>
  );
};

export default EventShareCard;
